<template>
  <div>
    <ContactForm :url="'/users/' + currentUser.id" :auth="userAuth" account-type="User" />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import ContactForm from '@/components/layout/ContactForm'

export default {
  name: 'Contact',
  components: {
    ContactForm
  },
  computed: {
    ...mapState(['currentUser', 'userAuth'])
  }
}
</script>
